import { BaseController } from "./BaseController";
import { TierRepository } from "../repository/TierRepository";

/**
 * 사용자 관련 비즈니스 로직을 처리하는 Controller 클래스입니다.
 */
export class TierController extends BaseController {
  static instance = null;

  /**
   * TierController의 인스턴스를 반환합니다.
   * @returns {TierController} TierController 인스턴스
   */
  static getInstance() {
    if (!TierController.instance) {
      TierController.instance = new TierController();
    }
    return TierController.instance;
  }

  /**
   * TierController 생성자
   */
  constructor() {
    super(new TierRepository());
  }

  /**
   * 티어 정보 목록을 조회합니다.
   * @returns {Promise<Object>} 티어 정보 목록
   */
  async getAll() {
    try {
      return await this.repository.findAll();
    } catch (error) {
      console.error("Error in tier.getAll:", error);
      throw error;
    }
  }
}
